var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "p",
        {
          staticClass: "text-center lead",
          staticStyle: { "font-size": "1.5rem" },
        },
        [
          _vm._v("\n        How would you rate: "),
          _c(
            "a",
            {
              staticClass: "text-primary",
              attrs: { title: "Show description" },
              on: { click: _vm.showAlternativeDetails },
            },
            [_vm._v(_vm._s(_vm.alternativeName))]
          ),
          _c("br"),
          _vm._v("\n        in the context of: "),
          _c(
            "a",
            {
              staticClass: "text-primary",
              attrs: { title: "Show description" },
              on: { click: _vm.showCriterionDetails },
            },
            [_vm._v(_vm._s(_vm.contextName))]
          ),
          _vm._v("?\n    "),
        ]
      ),
      _vm._v(" "),
      _vm.isMeetingManager === true
        ? [
            _c("div", { staticClass: "card card-collapsable mt-1" }, [
              _c(
                "div",
                {
                  staticClass: "card-header pointer",
                  attrs: { "data-toggle": "collapse", href: "#cardQuestion" },
                },
                [_vm._v("\n                Group vote\n            ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "card-body collapse show pt-4",
                  attrs: { id: "cardQuestion" },
                },
                [
                  _c("div", { staticStyle: { "min-height": "450px" } }, [
                    _c(
                      "div",
                      { staticClass: "list-group" },
                      _vm._l(_vm.scaleLevels, function (l) {
                        return _c(
                          "a",
                          {
                            key: l.Value,
                            staticClass:
                              "list-group-item list-group-item-action text-center",
                            class: {
                              "bg-success": _vm.value === l.Value,
                              "bg-white": _vm.value !== l.Value,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.updateValue(l.Value)
                              },
                            },
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(l.Value) + " - " + _vm._s(l.Name)),
                            ]),
                            _vm._v(" "),
                            l.Definition
                              ? _c("p", { staticClass: "mb-0" }, [
                                  _vm._v(_vm._s(l.Definition)),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn mt-3",
                          class:
                            _vm.value == null
                              ? "btn-success"
                              : "btn-outline-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.updateValue(null)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-regular",
                            class:
                              _vm.value == null
                                ? "fa-square-check"
                                : "fa-square",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            "\n                            Follow the average (default)\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-top": "15px" } }, [
                      _c("textarea", {
                        staticClass: "form-control",
                        attrs: { rows: "5", placeholder: "Comment..." },
                        domProps: { value: _vm.comment },
                        on: {
                          input: function ($event) {
                            return _vm.updateComment($event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isMeetingManager === false
        ? [
            _c("div", { staticStyle: { "min-height": "450px" } }, [
              _c(
                "div",
                { staticClass: "list-group" },
                _vm._l(_vm.scaleLevels, function (l) {
                  return _c(
                    "a",
                    {
                      key: l.Value,
                      staticClass:
                        "list-group-item list-group-item-action text-center",
                      class: {
                        "bg-success": _vm.value === l.Value,
                        "bg-white": _vm.value !== l.Value,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateValue(l.Value)
                        },
                      },
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(l.Value) + " - " + _vm._s(l.Name)),
                      ]),
                      _vm._v(" "),
                      l.Definition
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(_vm._s(l.Definition)),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.value != null
                ? _c("div", { staticClass: "text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link mt1",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.updateValue(null)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-times",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Clear answer\n                "),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "15px" } }, [
                _c("textarea", {
                  staticClass: "form-control",
                  attrs: { rows: "5", placeholder: "Comment..." },
                  domProps: { value: _vm.comment },
                  on: {
                    input: function ($event) {
                      return _vm.updateComment($event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isMeetingManager === true || _vm.votesEntries?.length
        ? _c(
            "div",
            {
              staticClass: "mt-4 DirectRateVotesBrowserView",
              staticStyle: { "min-height": "500px" },
            },
            [
              _c("ul", { staticClass: "nav nav-tabs" }, [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.VotesTabActive },
                      on: {
                        click: function ($event) {
                          _vm.ActiveTab = "votes"
                        },
                      },
                    },
                    [_vm._v("Votes")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.SummaryTabActive },
                      on: {
                        click: function ($event) {
                          _vm.ActiveTab = "summary"
                        },
                      },
                    },
                    [_vm._v("Chart")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.CommentsTabActive },
                      on: {
                        click: function ($event) {
                          _vm.ActiveTab = "notes"
                        },
                      },
                    },
                    [_vm._v("Comments")]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tab-content" }, [
                _vm.VotesTabActive
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane pt-2",
                        class: { active: _vm.VotesTabActive },
                      },
                      [
                        _c("div", { staticClass: "table-responsive" }, [
                          _c("table", { staticClass: "table table-striped" }, [
                            _c(
                              "tbody",
                              [
                                _c(
                                  "tr",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            "Average (" +
                                              _vm._s(
                                                _vm.Average != null
                                                  ? _vm.Average.toFixedIfNeeded(
                                                      2
                                                    )
                                                  : "N/A"
                                              ) +
                                              ")"
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.AverageCells, function (cell) {
                                      return _c(
                                        "td",
                                        {
                                          class: {
                                            "bg-color-gray": cell.Highlighted,
                                          },
                                          style: {
                                            width:
                                              cell.Colspan === 1 ? "5%" : "10%",
                                          },
                                          attrs: { colspan: cell.Colspan },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class: {
                                                "fg-color-white":
                                                  cell.Highlighted,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    cell.Value.toFixedIfNeeded(
                                                      2
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.VotesEntriesView, function (e) {
                                  return _c(
                                    "tr",
                                    {
                                      key: e.Id,
                                      staticStyle: { "text-align": "center" },
                                    },
                                    [
                                      _c(
                                        "td",
                                        {
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                e.VotesSourceName ?? "???"
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(e.cells, function (cell) {
                                        return _c(
                                          "td",
                                          {
                                            key: cell.Value,
                                            class: {
                                              "bg-color-green":
                                                cell.Highlighted,
                                            },
                                            attrs: { colspan: cell.Colspan },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class: {
                                                  "fg-color-white":
                                                    cell.Highlighted,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      cell.Value.toFixedIfNeeded(
                                                        2
                                                      )
                                                    ) +
                                                    "\n                                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                    ],
                                    2
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.SummaryTabActive
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane pt-2",
                        class: { active: _vm.SummaryTabActive },
                      },
                      [
                        _c("div", { staticClass: "table-responsive" }, [
                          _c("table", { staticClass: "table" }, [
                            _c("tbody", [
                              _c(
                                "tr",
                                {
                                  staticClass: "bottom noborder",
                                  staticStyle: { "text-align": "center" },
                                },
                                _vm._l(_vm.HistogramValues, function (v) {
                                  return _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        height: "400px",
                                        border: "none",
                                        "padding-top": "20px",
                                      },
                                    },
                                    [
                                      v.Count
                                        ? _c("div", [_vm._v(_vm._s(v.Count))])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "bg-color-green2",
                                        style: { height: v.PercentOfMax + "%" },
                                      }),
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "tr",
                                { staticStyle: { "text-align": "center" } },
                                _vm._l(_vm.HistogramValues, function (v) {
                                  return _c(
                                    "td",
                                    { staticStyle: { width: "5%" } },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(v.Value.toFixedIfNeeded(2)) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.CommentsTabActive
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-pane pt-2",
                        class: { active: _vm.CommentsTabActive },
                      },
                      _vm._l(_vm.Comments, function (c) {
                        return _c("blockquote", { staticClass: "blockquote" }, [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(_vm._s(c.Comment)),
                          ]),
                          _vm._v(" "),
                          _c("footer", { staticClass: "blockquote-footer" }, [
                            _vm._v(_vm._s(c.VotesSourceName ?? "???")),
                          ]),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }